import type { IBaseAction, IActionPerformer } from '@models/actions/IBaseAction';

export const getActionPerformer = (action: IBaseAction): IActionPerformer | undefined =>
    action.baseDisplayName?.trim() && action.performer?.name?.trim() ? action.performer : undefined;

/** Скобки могут быть частью названия операции: отделяем человека только по контракту API. */
export const getActionLabel = (action: IBaseAction, compact = false): string => {
    if (!getActionPerformer(action)) return action.displayName;
    const participantLabel = action.options?.menu?.participantLabel;
    return compact && typeof participantLabel === 'string' && participantLabel.trim()
        ? participantLabel.trim()
        : action.baseDisplayName!;
};

export const getActionSearchText = (action: IBaseAction): string =>
    [action.displayName, getActionLabel(action), getActionLabel(action, true), getActionPerformer(action)?.name].join(
        ' ',
    );
